// DashContentCard — Uppercase title + children in flex column
// Corporate card style with top accent border

import { DASH_CONTENT_CARD, DASH_CARD_TITLE } from './dashboardStyles';

interface DashContentCardProps {
  title: string;
  children: React.ReactNode;
}

export function DashContentCard({ title, children }: DashContentCardProps) {
  return (
    <div style={{ ...DASH_CONTENT_CARD, flex: 1 }}>
      <h3 style={DASH_CARD_TITLE}>{title}</h3>
      {children}
    </div>
  );
}
